import { render } from "./hcaptcha-submit-button.vue?vue&type=template&id=03538bc8"
import script from "./hcaptcha-submit-button.vue?vue&type=script&lang=js"
export * from "./hcaptcha-submit-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__